import { BitmapText, Container, Sprite, Texture } from 'pixi.js'
import { SymbolType } from '../enum/SymbolType'
import { SlotSymbolInfo } from '../../placeOrder/api/PlaceOrderResponse'

export function changeNode(symbol: Container, info: SlotSymbolInfo) {
  const bimapTextNode = symbol.getChildAt(1) as BitmapText
  bimapTextNode.visible = false
  symbol.name = info.symbol.toString()
  if (info.multiplier > 0) {
    bimapTextNode.text = `x${info.multiplier.toString()}`
    bimapTextNode.fontSize = bombFontSize(info.multiplier)
    bimapTextNode.scale = { x: 1, y: 1 }
    bimapTextNode.visible = true
    if (info.multiplier < 25) {
      bimapTextNode.fontName = 'FontS'
    }
    else {
      bimapTextNode.fontName = 'FontW'
    }
  }
  else {
    bimapTextNode.text = `x0`
    bimapTextNode.fontSize = bombFontSize(info.multiplier)
    bimapTextNode.scale = { x: 1, y: 1 }
  }

  const symbolImage = (symbol.getChildAt(0) as Container).getChildAt(0) as Sprite
  if (symbolImage) {
    symbolImage.texture = Texture.from(SymbolType[info.symbol])
  }
}

export function sleep(time: number) {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}

function bombFontSize(multiplierAmount: number) {
  const value = multiplierAmount
  switch (true) {
    case value >= 10 && value <= 99:
      return 36
    case value >= 100 && value <= 999:
      return 32
    default:
      return 36
  }
}
